"use client";

import i18next, { FlatNamespace, KeyPrefix } from "i18next";
import { useTranslation as useTranslationOrg, UseTranslationOptions, UseTranslationResponse, FallbackNs, initReactI18next } from "react-i18next";
import { fallbackLng, getI18nLang, mergeObjects } from "./settings";
// -------------- lang -------------------- //
import en_GB from "./locales/en_GB.json";
import zh_CN from "./locales/zh_CN.json";
import zh_TW from "./locales/zh_TW.json";
import de_DE from "./locales/de_DE.json";
import fr_FR from "./locales/fr_FR.json";
import nl_NL from "./locales/nl_NL.json";
// -------------- lang static -------------------- //
import en_GB_static from "./static/en_GB_static.json";
import zh_CN_static from "./static/zh_CN_static.json";
import zh_TW_static from "./static/zh_TW_static.json";
import de_DE_static from "./static/de_DE_static.json";
import fr_FR_static from "./static/fr_FR_static.json";
import nl_NL_static from "./static/nl_NL_static.json";
import { supportedLngs } from "./i18nConst";

i18next.use(initReactI18next).init({
  lng: getI18nLang(), // let detect the language on client side
  supportedLngs: supportedLngs,
  debug: false,
  preload: supportedLngs,
  fallbackLng: fallbackLng,
  resources: {
    en: { translation: mergeObjects(en_GB, en_GB_static) },
    zh: { translation: mergeObjects(zh_CN, zh_CN_static) },
    zh_TW: { translation: mergeObjects(zh_TW, zh_TW_static) },
    nl: { translation: mergeObjects(nl_NL, nl_NL_static) },
    de: { translation: mergeObjects(de_DE, de_DE_static) },
    fr: { translation: mergeObjects(fr_FR, fr_FR_static) },
  },
});

export function useTranslation<Ns extends FlatNamespace, KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined>(
  lng?: string,
  ns?: Ns,
  options?: UseTranslationOptions<KPrefix>,
): UseTranslationResponse<FallbackNs<Ns>, KPrefix> {
  // -------------- useTranslation -------------------- //
  const ret = useTranslationOrg(ns, options);
  const { i18n } = ret;
  const i18nLang = i18n.language;
  const _lang = getI18nLang();

  if (i18nLang !== _lang) {
    i18n.changeLanguage(_lang);
  }

  return ret;
}
